import React, {Component} from 'react'

import {Vector2} from 'utils/MathUtils.js'

import Confetti from './Confetti.js';



const animationFrequency = 50;
const animationPeriod = (1.0 / animationFrequency);
const confettiPaperCount = 100;
const DEG_TO_RAD = Math.PI / 180;
const RAD_TO_DEG = 180 / Math.PI;
const colors = [
        ["#df0049", "#660671"],
        ["#00e857", "#005291"],
        ["#2bebbc", "#05798a"],
        ["#ffd200", "#b06c00"]
      ];





class ConfettiContainer extends Component {
    constructor(props) {
        super(props);
        this.running = false;
        this.bounds = new Vector2(window.innerWidth, window.innerHeight);
        this.timerId = null;
        this.canvas = null;
        this.context = null;
        this.setCanvas = this.setCanvas.bind(this);
        this.onResizeWindow = this.onResizeWindow.bind(this);
        this.update = this.update.bind(this);
        
        this.confettiPapers = [];
        for (var i = 0; i < confettiPaperCount; i++) {
          this.confettiPapers[i] = new ConfettiPaper(Math.random() * this.bounds.x, Math.random() * this.bounds.y, this.bounds);
        }



        this.cAF = (window.cancelAnimationFrame  || window.cancelRequestAnimationFrame).bind(window);
        this.rAF = (window.requestAnimationFrame || window.webkitRequestAnimationFrame).bind(window);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResizeWindow);
        this.componentMountedAt = new Date().getTime();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResizeWindow);
        this.stop()
        this.componentMountedAt = null;
    }

    onResizeWindow() {
        this.setBounds();
    }

    setCanvas(ref) {
        this.canvas = ref;
        if(this.canvas) {
            this.setBounds();
            this.start();
        }
    }

    setBounds() {
        this.bounds.x     = window.innerWidth;
        this.bounds.y     = window.innerHeight;
        if(this.canvas) {
            this.canvas.width = window.innerWidth;
            this.canvas.height= window.innerHeight;
        }
    }

    update() {
        var respawn = this.props.duration ? this.componentMountedAt + this.props.duration > (new Date()).getTime() : true;
        this.context = this.canvas.getContext('2d');
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        var allExpired = true;
        for (var i = 0; i < confettiPaperCount; i++) {
            allExpired &= this.confettiPapers[i].update(animationPeriod, respawn);
            this.confettiPapers[i].draw(this.context);
        }
        if(allExpired) {
            this.stop();
        }
        if(this.running) {
            this.timerId = this.rAF( this.update );
        }
    }

    start() {
        if(!this.running) {
            this.running = true;
            this.update();
        }
    }
    stop() {
        console.log('Confetti stopped');
        this.running = false;
        this.canvas = null;
        this.context= null;
        if(this.timerId) {
            this.cAF(this.timerId);
            this.timerId = null;
        }
    }


    render() {
        return <Confetti {...this.props} setCanvas={this.setCanvas}/>
    }
}






class ConfettiPaper {
    constructor(x, y, bounds) {
        this.expired = false;
        this.bounds = bounds;
        this.pos = new Vector2(x, y);
        this.rotationSpeed = (Math.random() * 600 + 800);
        this.angle = DEG_TO_RAD * Math.random() * 360;
        this.rotation = DEG_TO_RAD * Math.random() * 360;
        this.cosA = 1.0;
        this.size = 5.0;
        this.oscillationSpeed = (Math.random() * 1.5 + 0.5);
        this.xSpeed = 40.0;
        this.ySpeed = (Math.random() * 60 + 50.0);
        this.corners = new Array();
        this.time = Math.random();
        var ci = Math.round(Math.random() * (colors.length - 1));
        this.frontColor = colors[ci][0];
        this.backColor = colors[ci][1];
        for (var i = 0; i < 4; i++) {
          var dx = Math.cos(this.angle + DEG_TO_RAD * (i * 90 + 45));
          var dy = Math.sin(this.angle + DEG_TO_RAD * (i * 90 + 45));
          this.corners[i] = new Vector2(dx, dy);
        }
    }

    update(dt, respawn) {
        if(this.expired) {
            return true;
        }
        this.time += dt;
        this.rotation += this.rotationSpeed * dt;
        this.cosA = Math.cos(DEG_TO_RAD * this.rotation);
        this.pos.x += Math.cos(this.time * this.oscillationSpeed) * this.xSpeed * dt
        this.pos.y += this.ySpeed * dt;
        if (this.pos.y > this.bounds.y) {
            if(respawn) {
                this.pos.x = Math.random() * this.bounds.x;
                this.pos.y = 0;
            } else {
                this.expired = true;
            }
        }
        return false;
    }

    draw(context) {
        if(this.expired) {
            return;
        }

        if (this.cosA > 0) {
            context.fillStyle = this.frontColor;
        } else {
            context.fillStyle = this.backColor;
        }
        context.beginPath();
        context.moveTo((this.pos.x + this.corners[0].x * this.size) , (this.pos.y + this.corners[0].y * this.size * this.cosA) );
        for (var i = 1; i < 4; i++) {
            context.lineTo((this.pos.x + this.corners[i].x * this.size) , (this.pos.y + this.corners[i].y * this.size * this.cosA) );
        }
        context.closePath();
        context.fill();
    }
}


export default ConfettiContainer;



// WEBPACK FOOTER //
// ./src/modules/misc/ConfettiContainer.js